import { Formik } from "formik";
import { memo, MutableRefObject, useCallback, useRef } from "react";

import validationSchema from "./GroupForm.schema";
import { useInitialState, useSubmitHandler } from "./GroupForm.hooks";
import GroupForm from "./GroupForm.component";
import {
  ActionGroupQualityReviewMap,
  IManagementProps,
} from "./GroupForm.types";
import { InitActionGroup } from "./GroupForm.constants";
import { IAISuggestions } from "types";

type GroupFormFormikValues = Partial<InitActionGroup> & {
  suggestedResult?: IAISuggestions;
};

interface IProps extends IManagementProps {
  className?: string;
  groupFormRef: MutableRefObject<boolean>;
  onSuccess: () => void;
  onClose: () => void;
}

function GroupFormContainer({
  className,
  onSuccess,
  onClose,
  showIssueFields = true,
  showRatings = true,
  groupFormRef,
}: IProps) {
  const similarRef = useRef<boolean>(false);
  const qualityReviewRef = useRef<ActionGroupQualityReviewMap>({});

  const onCloseCallback = useCallback(
    (id?: string) => {
      similarRef.current = false;
      groupFormRef.current = false;
      qualityReviewRef.current = {};
      if (onClose) {
        onClose();
      }
    },
    [groupFormRef, onClose]
  );

  return (
    <Formik<GroupFormFormikValues>
      enableReinitialize
      initialValues={useInitialState()}
      validationSchema={validationSchema()}
      onSubmit={useSubmitHandler(onSuccess, {
        showIssueFields,
        showRatings,
        proceedWithSimilar: similarRef.current,
        proceedWithSuggestions: groupFormRef.current,
        qualityReviewRef,
      })}
    >
      <GroupForm
        className={className}
        onClose={onCloseCallback}
        similarRef={similarRef}
        suggestionsRef={groupFormRef}
        showIssueFields={showIssueFields}
        showRatings={showRatings}
        qualityReviewRef={qualityReviewRef}
      />
    </Formik>
  );
}

export default memo(GroupFormContainer);
